import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { useMemo, useRef } from 'react';
import { COLUMN_MODE_PANEL_HEIGHT_PERCENT, ROW_MODE_PANEL_WIDTH_PERCENT } from '../../constants/constants';
import { useIsRowLayoutMode } from '../../hooks/useIsRowLayoutMode';
import { usePokerSceneResize } from '../../hooks/usePokerSceneResize';
import { useAppSelector } from '../../redux/store';
import { uuid } from '../../utils/utils';
import { DomBetControlsRouter } from './domBetControlsRouter';
import { DroppableSeatsContainer } from './droppableSeatsContainer';
import { PokerTableStage } from './pokerTableStage';
const CONTAINER_BASE_CSS = css `
  position: absolute;
`;
export const PokerTableStageContainer = () => {
    const isPanelOpen = useAppSelector((state) => !!state.panels.activePanelType);
    const isRowLayoutMode = useIsRowLayoutMode();
    const containerRef = useRef(null);
    const stageContainerUuid = useRef(uuid()); // used to track unmounting of specific pixi app/stage instances
    usePokerSceneResize(containerRef);
    const style = useMemo(() => isRowLayoutMode
        ? {
            width: `${isPanelOpen ? 100 - ROW_MODE_PANEL_WIDTH_PERCENT : 100}%`,
            height: '100%',
            left: 0,
            top: 0
        }
        : {
            width: '100%',
            height: `${isPanelOpen ? 100 - COLUMN_MODE_PANEL_HEIGHT_PERCENT : 100}%`,
            left: 0,
            bottom: 0
        }, [isPanelOpen, isRowLayoutMode]);
    return (_jsxs("div", { ref: containerRef, "data-testid": 'poker-stage-container', "data-stage-container-uuid": stageContainerUuid.current, css: CONTAINER_BASE_CSS, style: style, children: [_jsx(PokerTableStage, {}), _jsx(DroppableSeatsContainer, {}), _jsx(DomBetControlsRouter, {})] }));
};
